import { render, staticRenderFns } from "./FileTags.vue?vue&type=template&id=26c523d6&"
import script from "./FileTags.vue?vue&type=script&lang=js&"
export * from "./FileTags.vue?vue&type=script&lang=js&"
import style0 from "./FileTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports